import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import axios from "axios";
import { FaSearch } from "react-icons/fa";

const Notifications = () => {
  const {
    unverifiedEmailWorkerUsers,
    unverifiedPhoneWorkerUsers,
    profilePhotoReviewUsers,
    bioReviewUsers,
    unverifiedWorkerEmailCount,
    unverifiedWorkerPhoneCount,
    profilePhotoReviewCount,
    bioReviewCount,
    totalUnverifiedWorkerCount,
    getUnverifiedWorkerUsersAndCounts,
  } = useUser();
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const searchInputRef = useRef(null);

  useEffect(() => {
    getUnverifiedWorkerUsersAndCounts();
    searchInputRef.current.focus();
  }, [getUnverifiedWorkerUsersAndCounts]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const allUnverifiedWorkerUsers = [
    ...unverifiedEmailWorkerUsers,
    ...unverifiedPhoneWorkerUsers,
    ...profilePhotoReviewUsers,
    ...bioReviewUsers,
  ];

  const uniqueUsers = Array.from(
    new Map(allUnverifiedWorkerUsers.map((user) => [user.id, user])).values()
  );

  const filteredUsers = uniqueUsers.filter((user) =>
    `${user.firstName} ${user.lastName}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  console.log("Filtered Users:", filteredUsers);

  const resendVerificationEmail = async (userId) => {
    try {
      await axios.post(`/api/resend-email`, { userId });
      alert("Verification email sent successfully!");
    } catch (err) {
      console.error("Failed to resend verification email:", err);
      alert("Failed to resend verification email. Please try again later.");
    }
  };

  const resendPhoneVerification = async (userId) => {
    try {
      await axios.post(`/api/resend-phone-verification`, { userId });
      alert("Verification code sent successfully!");
    } catch (err) {
      console.error("Failed to resend phone verification code:", err);
      alert(
        "Failed to resend phone verification code. Please try again later."
      );
    }
  };

  const reviewPhoto = (userId) => {
    navigate(`/admin/review-photo/${userId}`);
  };

  const reviewBio = (userId) => {
    navigate(`/admin/review-bio/${userId}`);
  };

  return (
    <div className="admin-notifications-container">
      <div className="notifications-search-container">
        <input
          type="text"
          placeholder="Search by name"
          value={searchQuery}
          onChange={handleSearchChange}
          ref={searchInputRef}
        />
        <FaSearch className="notifications-search-icon" />
      </div>
      <div className="notification-grid-container">
        {filteredUsers.length > 0 ? (
          filteredUsers.map((user) => (
            <div key={user.id} className="admin-notification-content">
              <div className="notification-user-name">
                <strong>
                  {user.firstName} {user.lastName}
                </strong>
              </div>
              {!user.isEmailVerified && (
                <div className="notification-item">
                  <div className="icon-container alert" />
                  <p>Email verification pending.</p>
                  <button onClick={() => resendVerificationEmail(user.id)}>
                    Resend Email
                  </button>
                </div>
              )}
              {!user.phoneNumberVerified && (
                <div className="notification-item">
                  <div className="icon-container alert" />
                  <p>Phone number verification pending.</p>
                  <button onClick={() => resendPhoneVerification(user.id)}>
                    Resend Code
                  </button>
                </div>
              )}
              {user.profilePhotoUpdated && (
                <div className="notification-item">
                  <div className="icon-container warning" />
                  <p>Profile photo updated and needs review.</p>
                  <button onClick={() => reviewPhoto(user.id)}>
                    Review Photo
                  </button>
                </div>
              )}
              {user.bioUpdated && (
                <div className="notification-item">
                  <div className="icon-container warning" />
                  <p>Bio updated and needs review.</p>
                  <button onClick={() => reviewBio(user.id)}>Review Bio</button>
                </div>
              )}
            </div>
          ))
        ) : (
          <p>No users found matching your search.</p>
        )}
      </div>
    </div>
  );
};

export default Notifications;
